import React, { useContext, useState } from 'react';

import AuthContext from '../../../services/firebase/AuthContext';
import CreateReferrerContent from './CreateReferrerContent';
import FireDataContext from '../../../services/firebase/FireDataContext';
import { keyGen } from '../../../services/keygen';
import MemberMiniMenu from '../../members/menus/MemberMiniMenu';
import { timestamp } from '../../../app/data/validate';
import { navigate } from '@reach/router';

const CreateReferrerPage = () => {
    const { currentUser: { uid } } = useContext(AuthContext);
    const db = useContext(FireDataContext);

    const [referrer] = useState({
        id: `0000${keyGen(6)}`,
        email: '',
        name: '',
        organization: '0000',
        phone: '',
        roles: ['customer'],
        uid,
        verified: false,
        pseudo: true
    });

    const handleSubmit = () => {
        console.log('referrer', referrer);

        db.update({
            path: `users/${referrer.id}`,
            payload: {
                ...referrer, ts: timestamp()
            },
            context: 'CreateReferrerPage'
        })
            // now navigate to select firm page 
            .then(() => {
                console.log('created', referrer);
                navigate(`/admin/referrers/organization/${referrer.id}`);
            })
            .catch(error => console.log(error));
    }

    return (
        <MemberMiniMenu>
            <CreateReferrerContent referrer={referrer} onSubmit={handleSubmit} />
        </MemberMiniMenu>
    );
};

export default CreateReferrerPage;